import React, { useContext, useState } from 'react';
import { Navigate } from 'react-router-dom';
import {
  Box,
  Container,
  makeStyles,
  Typography,
  Grid,
  Paper,
} from '@material-ui/core';
import Page from 'src/components/Page';

import Input from '../../../shared/component/FormElements/Input';
import Button from '../../../shared/component/FormElements/Button';
import ErrorMessage from '../../../shared/component/UIElements/ErrorMessage';
import LoadingSpinner from '../../../shared/component/UIElements/LoadingSpinner';
import { VALIDATOR_REQUIRE } from '../../../utils/validators';
import { useForm } from '../../../hooks/form-hook';
import { useHttpClient } from '../../../hooks/http-hook';
import { AuthContext } from '../../../shared/context/auth-context';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  titulo: {
    color: '#3A3A3A',
    fontWeight: 700,
    fontSize: '24px',
    marginBottom: '15px'
  },
  button: {
    marginTop: '15px',
    display: 'block'
  }
}));

const Nova = () => {
  const classes = useStyles();
  const auth = useContext(AuthContext);
  const [navegar, setNavegar] = useState(false);

  const {
    isLoading,
    error,
    sendRequest,
    clearError
  } = useHttpClient();
  const [formState, inputHandler] = useForm({
    nome: {
      value: '',
      isValid: false
    },
  }, false);
  const novoSubmitHandler = async (event) => {
    event.preventDefault();
    try {
      const response = await sendRequest(
        `${process.env.REACT_APP_BACKEND_URL}/situacoes`,
        'POST',
        JSON.stringify({
          nome: formState.inputs.nome.value,
        }),
        {
          'Content-Type': 'application/json',
          'x-access-token': auth.token
        }
      );
      console.log(response);
      if (response.sucesso) {
        setNavegar('app/situacoes/');
      }
    } catch (err) {
      console.log(err);
    }
  };
  if (navegar) {
    return <Navigate to={`/${navegar}`} />;
  }
  return (
    <Page
      className={classes.root}
      title="Adicionar Nova Situações"
    >
      <Container maxWidth="md">
        <Paper p={3} style={{ padding: '15px' }}>
          <Box mt={3}>
            <form onSubmit={novoSubmitHandler}>
              <Box my={2}>
                <Typography
                  color="textPrimary"
                  align="left"
                  variant="h2"
                  className={classes.titulo}
                >
                  Cadastrar nova Situação
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Input
                      id="nome"
                      element="input"
                      type="text"
                      label="Nome da Situação"
                      fullWidth
                      validators={[VALIDATOR_REQUIRE()]}
                      errorText="Insira um nome para a Situação."
                      onInput={inputHandler}
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>
                </Grid>
                <Button
                  color="primary"
                  disabled={!formState.isValid}
                  fullWidth
                  size="large"
                  type="submit"
                  variant="contained"
                  marginBottom={5}
                  classes={classes.button}
                >
                  Salvar Situação
                </Button>
              </Box>
              {isLoading && <LoadingSpinner asOverlay />}
              <ErrorMessage error={error} onClear={clearError} />
            </form>
          </Box>
        </Paper>
      </Container>
    </Page>
  );
};
export default Nova;
